import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-loader',
  template: `<div class="mcrai-loader__bounce mcrai-loader__bounce--1"></div>
<div class="mcrai-loader__bounce mcrai-loader__bounce--2"></div>
<div class="mcrai-loader__bounce mcrai-loader__bounce--3"></div>
`,
  styles: [`.mcrai-loader{display:flex;width:100%;height:100%;align-items:center;justify-content:center}.mcrai-loader__bounce{flex:1;max-width:20px;max-height:20px;background-color:#dadada;margin:0 1px;border-radius:100%;display:inline-block;-webkit-animation:1.4s ease-in-out infinite both bouncedelay;animation:1.4s ease-in-out infinite both bouncedelay}.mcrai-loader__bounce:before{content:'';padding-top:100%;float:left}.mcrai-loader__bounce--1{-webkit-animation-delay:-.32s;animation-delay:-.32s}.mcrai-loader__bounce--2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes bouncedelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes bouncedelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent implements OnInit {
  readonly LOADER_CLASS = 'mcrai-loader';

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef,
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.LOADER_CLASS);
  }

}
